import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class KompBankService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(employeeId: number, stopDate: string): Observable<any[]> {
    // /api/kompbank/:employee_id/:stop_date
    return this.http.get<any[]>(`/api/kompbank/${employeeId}/${stopDate}`);
  }

  get2(employeeId: number, stopDate: string): Observable<any[]> {
    // /api/kompbank2/:employee_id/:stop_date
    return this.http.get<any[]>(`/api/kompbank2/${employeeId}/${stopDate}`);
  }

  delete(data: any): Observable<any> {
    // Legacy FortNoxKomp factory: return $resource("api/komp", {}, {});
    // Used in SalaryCtrl.kompUt: FortNoxKomp.delete(data, ...)
    // URL: /api/komp
    // Method: DELETE (default)
    // Legacy pass data in body? $resource delete accepts params.
    // For DELETE with body, explicit config needed usually?
    // In Angular HttpClient, delete(url, { body: ... }).
    return this.http.request('delete', '/api/komp', { body: data });
  }
}
